export default __webpack_public_path__ + "images/sj-4952c9a6d03f7d9caa08bffd322b3bce.svg";